module.exports = __webpack_public_path__ + "static/rooms1-6d55db4cb4f26deb6d87dd1ea98d5eb1.jpg";